$(document).on('turbo:load', function() {
  renderComponents();
});

$(document).on('turbo:frame-load', function() {
  renderComponents();
});

function renderComponents() {
  let renderComponent = null;
  let currentPriority = -Infinity;
  $('.render-component').each(function() {
    const priority = $(this).attr('priority') || 0;
    if (priority > currentPriority) {
      currentPriority = priority;
      renderComponent = $(this);
    }
  });

  if (!renderComponent) {
    $('[data-bs-toggle="tooltip"]').tooltip();
    $(".tipTop").tooltip({ placement : "top" });
    $(".tipRight").tooltip({ placement : "right" });
    $(".tipBottom").tooltip({ placement : "bottom" });
    $(".tipLeft").tooltip({ placement : "left" });
    initSearchableSelects();
    return;
  }

  const path = renderComponent.attr('path');
  const callback = renderComponent.attr('callback');
  $.get(path).done(function(html) {
    renderComponent.replaceWith(html);
    try {
      if (callback) eval(callback + '()');
    } catch {
      console.warn('Error with callback function in components.js:', callback)
    }
  }).fail(function(jqXHR, textStatus) {
    console.warn('Error loading component in components.js:', path, jqXHR.responseText);
    renderComponent.removeClass('render-component');
  }).always(function() {
    renderComponents();
  });
}

function reloadComponent(component, params=null) {
  // Find the closest component-base or the component itself
  const componentBase = component.hasClass('component-base') ? component : component.closest('.component-base');
  if (!componentBase.length) {
    console.warn('Tried to reload component that is not a component base or inside a component-base:', component);
    return;
  }

  // Get the path to reload from the component base
  let path = componentBase.attr('reload_path');
  if (!path) {
    console.warn('Tried to reload component without a path:', componentBase);
    return;
  }

  // Update the URL search params
  if (params) {
    const [basePath, search] = path.split('?');
    const searchParams = new URLSearchParams(search);
    Object.entries(params).forEach(([key, value]) => {
      searchParams.set(key, value.toString());
    });
    path = `${basePath}?${searchParams.toString()}`;
  }

  // Find the turbo-frame that contains the component base, or the highest level parent if there is none
  const turboFrame = componentBase.closest('turbo-frame');
  const componentParent = turboFrame.length ? turboFrame : componentBase;

  // Reload the component
  $.get(path).done(function(html) {
    componentParent.replaceWith(html);
    renderComponents();
  }).fail(function(jqXHR, textStatus) {
    console.warn('Error reloading component in components.js:', path, jqXHR.responseText);
  });
}

window.renderComponents = renderComponents;
window.reloadComponent = reloadComponent;

// Turn any <select class="searchable-select"> into a searchable single-select dropdown.
//
// Initialised here, alongside the tooltips, rather than from a component's own callback: a nested
// component (a tab rendered inside another component) is injected by renderComponents itself and
// never gets a callback of its own. This branch is only reached once every component on the page
// has landed, so the markup is guaranteed to exist.
//
// Idempotent - TomSelect stores itself on the element, so a second pass skips it. A component that
// needs different options (multi-select, extra plugins) still initialises TomSelect in its own
// callback; that runs first, and this pass leaves it alone.
function initSearchableSelects() {
  $('select.searchable-select').each(function () {
    if (this.tomselect) return;

    // maxOptions defaults to 50, which silently truncates a long list when the user is scrolling
    // rather than typing. These lists are the whole reason the control is searchable, so show them all.
    new TomSelect(this, { maxOptions: null });
  });
}
